<!-- CompetitionDetailsView.vue -->
<template>
    <div class="container box_component">
      <div v-if="checkRoles('Judge')" class="card p-0 m-0">
        <div class="card-header">
          {{ this.competitionDetails.name }}
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <div class="card mb-3">
                <div class="card-header d-flex justify-content-between align-items-center"
                     @click="toggleCollapseRounds(0)"
                     :aria-expanded="isExpanded[0] ? 'true' : 'false'"
                >
                  <h5>{{ $t('competitionDetails.card_1.title') }}</h5>
                  <button
                      class="btn btn-link"
                      type="button"
                  >
                    <i :class="['fas', isExpanded[0] ? 'fa-chevron-up' : 'fa-chevron-down']"></i>
                  </button>
                </div>
                <transition name="fade" @before-enter="beforeEnter" @enter="enter" @leave="leave">
                  <div v-if="isExpanded[0]" key="content" class="box">
                    <div class="card-body height_box">
                      <div v-if="competitionDetails.competition_users && competitionDetails.competition_users.length > 0">
                        <table class="table table-responsive table-bordered table-condensed">
                          <tbody>
                          <tr v-for="(user, index) in competitionDetails.competition_users" :key="user.id">
                            <td class="align-middle">{{ index + 1 }}</td>
                            <td class="align-middle">{{ user.user.name }}</td>
                            <td class="text-center align-middle">{{ user.user.surname }}</td>
                            <td class="text-center align-middle">{{ this.status_name(user.status_id) }}</td>
                            <td class="text-center align-middle">{{ user.role.name }}</td>
                            <td class="d-flex align-content-center justify-content-around">
                              <button @click="judgeRound(user.user.id)" class="btn btn-primary btn-sm">
                                <i class="fas fa-gavel text-white"></i>
                              </button>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                      <div v-else>
                        <p>{{ $t('competition.empty_box') }}</p>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
              <!-- Nuevo listado de Rounds -->
              <div>
                <div v-for="(rounds, roundNumber, index) in groupedRounds" :key="roundNumber" class="card mb-3">
                  <div class="card-header d-flex justify-content-between align-items-center"
                       @click="toggleCollapseRounds(roundNumber)"
                       :aria-expanded="isExpanded[roundNumber] ? 'true' : 'false'"
                  >
                    <h5>{{ getRoundName(roundNumber) }}</h5>
                    <button
                        class="btn btn-link"
                        type="button"

                    >
                      <i :class="['fas', isExpanded[roundNumber] ? 'fa-chevron-up' : 'fa-chevron-down']"></i>
                    </button>
                  </div>
                  <transition name="fade" @before-enter="beforeEnter" @enter="enter" @leave="leave">
                    <div v-if="isExpanded[roundNumber]" key="content" class="box">
                      <div class="card-body height_box">
                        <table class="table table-responsive table-bordered table-condensed">
                          <thead>
                          <tr>
                            <th>#</th>
                            <th>{{ $t('competitionDetails.card_1.name') }}</th>
                            <th>{{ $t('competitionDetails.card_1.surname') }}</th>
                            <th>{{ $t('competitionDetails.card_1.score') }}</th>
                            <th>Action</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="(round, index) in rounds" :key="round.id">
                            <td :class="{ 'best-result': round.is_best_result }">{{ index + 1 }}</td>
                            <td :class="{ 'best-result': round.is_best_result }">{{ round.user.name }}</td>
                            <td :class="{ 'best-result': round.is_best_result }">{{ round.user.surname }}</td>
                            <td :class="{ 'best-result': round.is_best_result }">{{ round.total_score }}</td>
                            <td class="d-flex align-content-center justify-content-around">
                              <!-- Botón hamburguesa visible en pantallas pequeñas -->
                              <div class="btn-group">
                                <button class="btn btn-secondary btn-sm dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                  <i class="fas fa-bars text-white"></i>
                                </button>
                                <!-- Menú desplegable con botones ocultos -->
                                <ul class="dropdown-menu list-btn">
                                  <li><button @click="viewRound(round.id)" class="btn btn-primary btn-sm"><i class="fa-solid fa-eye text-white"></i></button></li>
                                  <li><button @click="publishRound(round.id)" class="btn btn-warning btn-sm" disabled><i class="fa-regular fa-upload text-white"></i></button></li>
                                  <li><button @click="editRound(round.id)" class="btn btn-secondary btn-sm"><i class="fas fa-pencil-alt text-white"></i></button></li>
                                  <li><button @click="deleteRound(round.id)" class="btn btn-danger btn-sm"><i class="fas fa-trash text-white"></i></button></li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </transition>
                  <!-- Insertar mensaje después de la ronda 2 -->
                  <template v-if="index === 1">
                    <!-- Listado de Best Rounds (tercera posición) -->
                    <div v-if="groupedBest.length" class="card mt-3 mb-0">
                      <div class="card-header d-flex justify-content-between align-items-center"
                           @click="toggleCollapseBestRounds"
                           :aria-expanded="isBestExpanded ? 'true' : 'false'"
                      >
                        <h5>{{ $t('competitionDetails.card_1.best') }}</h5>
                        <button
                            class="btn btn-link"
                            type="button"
                        >
                          <i :class="['fas', isBestExpanded ? 'fa-chevron-up' : 'fa-chevron-down']"></i>
                        </button>
                      </div>
                      <transition name="fade" @before-enter="beforeEnter" @enter="enter" @leave="leave">
                        <div v-if="isBestExpanded" key="content" class="box">
                          <div class="card-body height_box">
                            <table class="table table-responsive table-bordered table-condensed">
                              <thead>
                              <tr>
                                <th>#</th>
                                <th>{{ $t('competitionDetails.card_1.name') }}</th>
                                <th>{{ $t('competitionDetails.card_1.surname') }}</th>
                                <th>{{ $t('competitionDetails.card_1.score') }}</th>
                                <th>Action</th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr v-for="(round, index) in groupedBest" :key="round.id">
                                <td class="best-result">{{ index + 1 }}</td>
                                <td class="best-result">{{ round.user.name }}</td>
                                <td class="best-result">{{ round.user.surname }}</td>
                                <td class="best-result">{{ round.total_score }}</td>
                                <td class="d-flex align-content-center justify-content-around">
                                  <!-- Botón hamburguesa visible en pantallas pequeñas -->
                                  <div class="btn-group">
                                    <button class="btn btn-secondary btn-sm dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                      <i class="fas fa-bars text-white"></i>
                                    </button>
                                    <!-- Menú desplegable con botones ocultos -->
                                    <ul class="dropdown-menu list-btn">
                                      <li><button @click="viewRound(round.id)" class="btn btn-primary btn-sm"><i class="fa-solid fa-eye text-white"></i></button></li>
                                      <li><button @click="publishRound(round.id)" class="btn btn-warning btn-sm" disabled><i class="fa-regular fa-upload text-white"></i></button></li>
                                      <li><button @click="editRound(round.id)" class="btn btn-secondary btn-sm"><i class="fas fa-pencil-alt text-white"></i></button></li>
                                      <li><button @click="deleteRound(round.id)" class="btn btn-danger btn-sm"><i class="fas fa-trash text-white"></i></button></li>
                                    </ul>
                                  </div>
                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </transition>
                    </div>
                    <!-- Fin del listado de Best Rounds -->
                  </template>
                </div>
              </div>
              <!-- Fin del listado de Rounds -->
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="checkRoles('Athlete')" class="card p-0 m-0">
        <div class="card-header">
          {{ this.competitionDetails.name }}
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <div class="card mb-3">
                <div class="card-header d-flex justify-content-between align-items-center"
                     @click="toggleCollapseRounds(0)"
                     :aria-expanded="isExpanded[0] ? 'true' : 'false'"
                >
                  <h5>{{ $t('competitionDetails.card_1.title') }}</h5>
                  <button
                      class="btn btn-link"
                      type="button"
                  >
                    <i :class="['fas', isExpanded[0] ? 'fa-chevron-up' : 'fa-chevron-down']"></i>
                  </button>
                </div>
                <transition name="fade" @before-enter="beforeEnter" @enter="enter" @leave="leave">
                      <div v-if="competitionDetails.competition_users && competitionDetails.competition_users.length > 0 && isExpanded[0]" key="content" class="box">
                        <div class="card-body height_box">
                          <table class="table table-responsive table-responsive-sm table-bordered table-condensed">
                            <tbody>
                            <tr v-for="(user, index) in competitionDetails.competition_users" :key="user.id">
                              <td class="text-center align-middle">{{ index + 1 }}</td>
                              <td class="text-center align-middle">
                                <img :src="user.user.img_path" alt="" class="rounded-circle img-thumbnail">
                              </td>
                              <td class="text-center align-middle">{{ user.user.name + ' ' + user.user.surname }}</td>
                              <td class="text-center align-middle">{{ user.user.country ? user.user.country.emoji : '' }}</td>
                            </tr>
                            </tbody>
                          </table>
                      </div>
                    </div>
                </transition>
              </div>
              <!-- Nuevo listado de Rounds -->
              <div>
                <div v-for="(rounds, roundNumber, index) in groupedRounds" :key="roundNumber" class="card mb-3">
                  <div class="card-header d-flex justify-content-between align-items-center"
                       @click="toggleCollapseRounds(roundNumber)"
                       :aria-expanded="isExpanded[roundNumber] ? 'true' : 'false'"
                  >
                    <h5>{{ getRoundName(roundNumber) }}</h5>
                    <button
                        class="btn btn-link"
                        type="button"
                    >
                      <i :class="['fas', isExpanded[roundNumber] ? 'fa-chevron-up' : 'fa-chevron-down']"></i>
                    </button>
                  </div>
                  <transition name="fade" @before-enter="beforeEnter" @enter="enter" @leave="leave">
                    <div v-if="isExpanded[roundNumber]" key="content" class="box">
                      <div class="card-body height_box">
                        <table class="table table-responsive table-bordered table-condensed">
                          <tbody>
                          <tr v-for="(round, index) in rounds" :key="round.id">
                            <td :class="['text-center', 'align-middle', { 'best-result': round.is_best_result }]">{{ index + 1 }}</td>
                            <td :class="['text-center', 'align-middle', { 'best-result': round.is_best_result }]">
                              <img :src="round.user.img_path" alt="" class="rounded-circle img-thumbnail">
                            </td>
                            <td :class="['text-center', 'align-middle', { 'best-result': round.is_best_result }]">{{ round.user.name + ' ' + round.user.surname }}</td>
                            <td :class="['text-center', 'align-middle', { 'best-result': round.is_best_result }]"><b>{{ round.total_score }}</b></td>
                            <td :class="['text-center', 'align-middle', { 'best-result': round.is_best_result }]">
                              <button @click="viewRound(round.id)" class="btn btn-primary btn-sm"><i class="fa-solid fa-eye text-white"></i></button>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </transition>
                  <!-- Insertar mensaje después de la ronda 2 -->
                  <template v-if="index === 1">
                    <!-- Listado de Best Rounds (tercera posición) -->
                    <div v-if="groupedBest.length" class="card mt-3 mb-0">
                      <div class="card-header d-flex justify-content-between align-items-center"
                           @click="toggleCollapseBestRounds"
                           :aria-expanded="isBestExpanded ? 'true' : 'false'"
                      >
                        <h5>{{ $t('competitionDetails.card_1.best') }}</h5>
                        <button
                            class="btn btn-link"
                            type="button"
                        >
                          <i :class="['fas', isBestExpanded ? 'fa-chevron-up' : 'fa-chevron-down']"></i>
                        </button>
                      </div>
                      <transition name="fade" @before-enter="beforeEnter" @enter="enter" @leave="leave">
                        <div v-if="isBestExpanded" key="content" class="box">
                          <div class="card-body height_box">
                            <table class="table table-responsive table-bordered table-condensed">
                              <tbody>
                              <tr v-for="(round, index) in groupedBest" :key="round.id">
                                <td class="text-center align-middle best-result">{{ index + 1 }}</td>
                                <td class="text-center align-middle best-result">
                                  <img :src="round.user.img_path" alt="" class="rounded-circle img-thumbnail">
                                </td>
                                <td class="text-center align-middle best-result">{{ round.user.name + ' ' + round.user.surname }}</td>
                                <td class="text-center align-middle best-result"><b>{{ round.total_score }}</b></td>
                                <td class="text-center align-middle best-result">
                                  <button @click="viewRound(round.id)" class="btn btn-primary btn-sm"><i class="fa-solid fa-eye text-white"></i></button>
                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </transition>
                    </div>
                    <!-- Fin del listado de Best Rounds -->
                  </template>
                </div>
              </div>
              <!-- Fin del listado de Rounds -->
            </div>
          </div>
        </div>
      </div>
      <div v-if="checkRoles('Judge')" class="card p-0 m-0">
        <div class="card-header">
          Test de Bracket
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <BracketGrid :players="players" :round_size_id="3"/>
              <!--              <BracketGrid :players="players" :options="{ rounds: ['Dieciseisavos', 'Octavos', 'Cuartos', 'Semifinal', 'Final'] }" />-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <ConfirmationModal
      ref="confirmationModal"
      :message="modalMessage"
      :showCancel="showCancel"
      :showRuleSelector="false"
      :ruleOptions="[]"
      :showNameInput="false"
      :initialRule="''"
      :initialName="''"
      @confirmed="handleConfirmed"
      @canceled="cancelModal"
    />
    <loading-modal ref="loadingModal"></loading-modal>
</template>

<script>
import ConfirmationModal from "@/components/competitions/ConfirmationModal.vue";
import LoadingModal from "@/services/LoadingModal.vue";
import BracketGrid from '@/components/BracketGrid.vue';
export default {
    name: "CompetitionDetailsView",
    data() {
        return {
            userProfile: this.$store.getters.getUser,
            nothing: [],
            totalRounds: [],
            userRounds: [],
            competitionDetails: [],
            userCompetitions: [],
            competitionRounds: [],
            publishedRounds: [],
            isExpanded: {},
            isBestExpanded: false,
            formData: {
                name: '',
                round_size_id: '',
                rule_id: '',
                type_id: '',
                country_id: '',
                state_id: '',
                city_id: '',
            },
            countries: [],
            states: [],
            cities: [],
            round_sizes: [],
            rules: [],
            types: [],
            groupedRounds: {},
            groupedBest: [],
            pendingConfirmResolver: null,
            showCancel: false,
            modalMessage: '',
          playersTest: [],
          players: {
            /*round32: [
              { id: 1, name: "Player 1", surname: "Smith", total_score: 100 },
              { id: 2, name: "Player 2", surname: "Johnson", total_score: null },
              { id: 3, name: "Player 3", surname: "Williams", total_score: null },
              { id: 4, name: "Player 4", surname: "Brown", total_score: null },
              { id: 5, name: "Player 5", surname: "Jones", total_score: null },
              { id: 6, name: "Player 6", surname: "Garcia", total_score: null },
              { id: 7, name: "Player 7", surname: "Martinez", total_score: null },
              { id: 8, name: "Player 8", surname: "Rodriguez", total_score: null },
              { id: 9, name: "Player 9", surname: "Hernandez", total_score: null },
              { id: 10, name: "Player 10", surname: "Lopez", total_score: null },
              { id: 11, name: "Player 11", surname: "Gonzalez", total_score: null },
              { id: 12, name: "Player 12", surname: "Wilson", total_score: null },
              { id: 13, name: "Player 13", surname: "Anderson", total_score: null },
              { id: 14, name: "Player 14", surname: "Thomas", total_score: null },
              { id: 15, name: "Player 15", surname: "Taylor", total_score: null },
              { id: 16, name: "Player 16", surname: "Moore", total_score: 90 },
              { id: 17, name: "Player 17", surname: "Jackson", total_score: 50 },
              { id: 18, name: "Player 18", surname: "Martin", total_score: null },
              { id: 19, name: "Player 19", surname: "Lee", total_score: null },
              { id: 20, name: "Player 20", surname: "Perez", total_score: null },
              { id: 21, name: "Player 21", surname: "Thompson", total_score: null },
              { id: 22, name: "Player 22", surname: "White", total_score: null },
              { id: 23, name: "Player 23", surname: "Harris", total_score: null },
              { id: 24, name: "Player 24", surname: "Sanchez", total_score: null },
              { id: 25, name: "Player 25", surname: "Clark", total_score: null },
              { id: 26, name: "Player 26", surname: "Ramirez", total_score: null },
              { id: 27, name: "Player 27", surname: "Lewis", total_score: null },
              { id: 28, name: "Player 28", surname: "Robinson", total_score: null },
              { id: 29, name: "Player 29", surname: "Walker", total_score: null },
              { id: 30, name: "Player 30", surname: "Young", total_score: null },
              { id: 31, name: "Player 31", surname: "Allen", total_score: null },
              { id: 32, name: "Player 32", surname: "King", total_score: 70 }
            ],*/
            /*
              round16: [
                { id: 1, name: "Player 1", surname: "Smith", total_score: null },
                { id: 2, name: "Player 2", surname: "Johnson", total_score: null },
                { id: 3, name: "Player 3", surname: "Williams", total_score: null },
                { id: 4, name: "Player 4", surname: "Brown", total_score: null },
                { id: 5, name: "Player 5", surname: "Jones", total_score: null },
                { id: 6, name: "Player 6", surname: "Garcia", total_score: null },
                { id: 7, name: "Player 7", surname: "Martinez", total_score: null },
                { id: 8, name: "Player 8", surname: "Rodriguez", total_score: null },
                { id: 9, name: "Player 9", surname: "Hernandez", total_score: null },
                { id: 10, name: "Player 10", surname: "Lopez", total_score: null },
                { id: 11, name: "Player 11", surname: "Gonzalez", total_score: null },
                { id: 12, name: "Player 12", surname: "Wilson", total_score: null },
                { id: 13, name: "Player 13", surname: "Anderson", total_score: null },
                { id: 14, name: "Player 14", surname: "Thomas", total_score: null },
                { id: 15, name: "Player 15", surname: "Taylor", total_score: null },
                { id: 16, name: "Player 16", surname: "Moore", total_score: null }
              ],
*/
            /*
                          round8: [
                            { id: 1, name: "Player 1", surname: "Smith", total_score: null },
                            { id: 2, name: "Player 2", surname: "Johnson", total_score: null },
                            { id: 3, name: "Player 3", surname: "Williams", total_score: null },
                            { id: 4, name: "Player 4", surname: "Brown", total_score: null },
                            { id: 5, name: "Player 5", surname: "Jones", total_score: null },
                            { id: 6, name: "Player 6", surname: "Garcia", total_score: null },
                            { id: 7, name: "Player 7", surname: "Martinez", total_score: null },
                            { id: 8, name: "Player 8", surname: "Rodriguez", total_score: null }
                          ],
            */
            /* round4: [
               { id: 1, name: "Player 1", surname: "Smith", total_score: null },
               { id: 2, name: "Player 2", surname: "Johnson", total_score: null },
               { id: 3, name: "Player 3", surname: "Williams", total_score: null },
               { id: 4, name: "Player 4", surname: "Brown", total_score: null }
             ],*/
            /*thirdPlace: [
              { id: 3, name: "Player 3", surname: "Williams", total_score: null },
              { id: 4, name: "Player 4", surname: "Brown", total_score: null }
            ],*/
            /* roundFinal: [
               { id: 1, name: "Player 1", surname: "Smith", total_score: null },
               { id: 2, name: "Player 2", surname: "Johnson", total_score: null }],*/

            round32: [

            ],
            round16: [

            ],
            round8: [

            ],
            round4: [

            ],
            thirdPlace: [

            ],
            roundFinal: [

            ]
            }
        };
    },
    computed: {
        roles() {
            return this.$store.getters.getRoles;
        },
    },
    mounted() {
        if (this.checkRoles('Judge')) {
            this.fetchCompetitionDetails(this.$store.state.competitionIdToView);
        }
        if (this.checkRoles('Athlete')) {
            this.fetchCompetitionDetails(this.$store.state.competitionIdToView);
        }
    },
    methods: {
        checkRoles(role_user) {
            return !!this.roles.find((role) => role.name === role_user);
        },
        async fetchCompetitionDetails(competitionId) {
            this.showLoading();
            try {
                const response = await this.$axios.get(`/competition/${competitionId}`, {
                    headers: {
                        Authorization: `Bearer ${this.$store.getters.getToken}`,
                    },
                });
                this.competitionDetails = response.data.competition;
              this.groupRoundsByNumber(this.competitionDetails.rounds);
              this.playersTest = JSON.parse(JSON.stringify(this.groupedRounds));
              this.playersTest.is_qualification_dual = this.competitionDetails.is_qualification_dual;
              this.playersTest.round_size_id = this.competitionDetails.round_size_id;
              this.playersTest.id = this.competitionDetails.id;
              if(this.playersTest.id === 8){
                this.playersTest.skip = [2];
              }else{
                this.playersTest.skip = [];
              }
              this.updatePlayerCounts();
                // this.isExpanded[7] = true;
                this.hideLoading();
            } catch (error) {
                console.error('Error al obtener las rondas:', error);
            }
        },
        judgeRound(userId) {
          console.log(`Juzgando el round del usuario con ID: ${userId}`);
          console.log(`Juzgando la competicion con ID:`+this.competitionDetails.id);
          this.$store.commit('setAthleteId', userId);
          this.$store.commit('setCompetitionIdToView', this.competitionDetails.id);
          this.$router.push('/judging');
        },
        async fetchUserCompetitions() {
              this.showLoading();
              try {
                  const response = await this.$axios.get("/competitions/list", {
                      headers: {
                          Authorization: `Bearer ${this.$store.getters.getToken}`,
                      },
                  });
              this.userCompetitions = Array.isArray(response.data?.competitions)
                ? response.data.competitions
                : Array.isArray(response.data)
                  ? response.data
                  : [];
                  this.isExpanded[7] = true;
                  this.hideLoading();
              } catch (error) {
                  console.error('Error al obtener las rondas:', error);
              }
          },
      groupRoundsByNumber(rounds) {
        const grouped = rounds.reduce((acc, round) => {
          const roundNumber = parseFloat(round.round_number);
          if (!acc[roundNumber]) {
            acc[roundNumber] = [];
          }
          acc[roundNumber].push(round);
          return acc;
        }, {});

        // Ordenar cada grupo por total_score de mayor a menor
        Object.keys(grouped).forEach(key => {
          grouped[key].sort((a, b) => parseFloat(b.total_score) - parseFloat(a.total_score));
        });

        const groupedBest = [];

        if (this.competitionDetails.is_qualification_dual === 1) {
          const bestRounds = {};
          Object.values(grouped).forEach(roundGroup => {
            roundGroup.forEach(round => {
              const userId = round.user.id;

              if (!bestRounds[userId]) {
                bestRounds[userId] = [];
              }

              bestRounds[userId].push(round);
            });
          });

          // Comparar el mejor resultado entre los rounds de cada atleta
          Object.keys(bestRounds).forEach(userId => {
            const userRounds = bestRounds[userId];
            userRounds.sort((a, b) => parseFloat(a.round_number) - parseFloat(b.round_number));
            if (userRounds.length > 1) {
              const round1 = userRounds[0];
              const round2 = userRounds[1];
              const bestRound = parseFloat(round1.total_score) >= parseFloat(round2.total_score) ? round1 : round2;
              bestRound.is_best_result = true; // Marcar el mejor round
              groupedBest.push(bestRound); // Añadir al array de mejores rounds
            }
          });

          // Ordenar groupedBest de mayor a menor por total_score
          groupedBest.sort((a, b) => parseFloat(b.total_score) - parseFloat(a.total_score));
        }

        this.groupedRounds = grouped;
        this.groupedBest = groupedBest;
      },
      async loadCountries() {
            try {
                this.showLoading();
                const response = await this.$axios.get("/countries",{
                        headers: {
                            Authorization: `Bearer ${this.$store.getters.getToken}`,
                        },
                    })
                    .catch(error => {
                        console.error('Error al obtener la lista de países:', error);
                });
                const countriesData = response.data.countries.map(country => {
                    let translatedName = country.name;
                    let langCode = this.$i18n.locale;
                    if (langCode !== 'en' && country.translations) {
                        try {
                            const translationsObject = JSON.parse(country.translations);
                            if (langCode === 'jp'){langCode = 'ja'}
                            translatedName = translationsObject[langCode] || country.name;
                        } catch (error) {
                            console.error('Error al parsear las traducciones:', error);
                        }
                    }

                    return {
                        id: country.id,
                        name: translatedName,
                    };
                });

                this.countries = countriesData.sort((a, b) => {
                    const nameA = a.name.toUpperCase();
                    const nameB = b.name.toUpperCase();
                    return nameA.localeCompare(nameB);
                });
                this.hideLoading();

            } catch (error) {
                console.error('Error loading countries:', error);
            }
        },
        async loadStatesForCountry(countryCode) {
            try {
                this.showLoading();
                const response = await this.$axios.get(`/states/${countryCode}`,{
                    headers: {
                        Authorization: `Bearer ${this.$store.getters.getToken}`,
                    },
                })
                    .catch(error => {
                        console.error('Error al obtener la lista de países:', error);
                    });
                const stateData = response.data.states.map(states => {
                    return {
                        id: states.id,
                        name: states.name,
                    };
                });

                this.states = stateData.sort((a, b) => {
                    const nameA = a.name.toUpperCase();
                    const nameB = b.name.toUpperCase();
                    return nameA.localeCompare(nameB);
                });
                this.hideLoading();
            } catch (error) {
                console.error('Error loading cities:', error);
            }
        },
        async loadCitiesForState(state) {
            try {
                this.showLoading();
                const response = await this.$axios.get(`/cities/${state}`,{
                    headers: {
                        Authorization: `Bearer ${this.$store.getters.getToken}`,
                    },
                })
                    .catch(error => {
                        console.error('Error al obtener la lista de países:', error);
                    });
                const citiesData = response.data.cities.map(cities => {
                    return {
                        id: cities.id,
                        name: cities.name,
                    };
                });
                this.cities = citiesData.sort((a, b) => {
                    const nameA = a.name.toUpperCase();
                    const nameB = b.name.toUpperCase();
                    return nameA.localeCompare(nameB);
                });
                this.hideLoading();
            } catch (error) {
                console.error('Error loading cities:', error);
            }
        },
        onCountryChange() {
            if (this.formData.country_id) {
                this.loadStatesForCountry(this.formData.country_id);
            }
        },
        onStateChange() {
            if (this.formData.state_id) {
                this.loadCitiesForState(this.formData.state_id);
            }
        },
        editRound(roundId) {
            this.$store.commit('setRoundIdToUpdate', roundId);
            this.$router.push('/judging');
        },
        viewRound(roundId) {
            this.$store.commit('setRoundIdToView', roundId)
            this.$router.push('/judging');
        },
        publishRound(roundId) {
            // Lógica para editar la ronda con el ID dado
            console.log('Publicar ronda con ID:', roundId);
        },
        async deleteRound(id) {
          const isConfirmed = await this.confirmWithModal('Are you sure you want to delete this round?');

          if (isConfirmed) {
            this.showLoading();
            try {
              const response = await this.$axios.delete(`/delete_round/${id}`, {
                headers: {
                  Authorization: `Bearer ${this.$store.getters.getToken}`,
                },
              });

              // Verificar si la eliminación fue exitosa (esto asume que el servidor devuelve un código de estado 200 para éxito)
              if (response.status === 200) {
                // Si la eliminación fue exitosa, remover los elementos de los arrays
                this.userRounds = this.userRounds.filter(round => round.id !== id);
                this.competitionRounds = this.competitionRounds.filter(round => round.id !== id);
                this.publishedRounds = this.publishedRounds.filter(round => round.id !== id);
              } else {
                // Si no se recibió un estado de éxito, arrojar un error
                throw new Error('Error en el servidor: no se pudo eliminar el registro.');
              }

              this.hideLoading();
            } catch (error) {
              console.error('Error al eliminar el registro:', error.response ? error.response.data : error.message);
              this.hideLoading();
              // Opcional: mostrar un mensaje de error al usuario
              this.$notify({
                type: 'error',
                title: 'Error',
                text: 'No se pudo eliminar el registro. Inténtalo de nuevo más tarde.',
              });
            }

          }
        },
        async deleteCompetition(id) {
          const isConfirmed = await this.confirmWithModal('Are you sure you want to delete this Competition?');

            if (isConfirmed) {
                this.showLoading();
              try {
                const response = await this.$axios.delete(`/competitions/${id}`, {
                  headers: {
                    Authorization: `Bearer ${this.$store.getters.getToken}`,
                  },
                });

                // Verificar si la eliminación fue exitosa (asumiendo que el servidor devuelve un código de estado 200 para éxito)
                if (response.status === 200) {
                  // Si la eliminación fue exitosa, actualizar las competiciones del usuario
                  await this.fetchUserCompetitions();
                } else {
                  // Si no se recibió un estado de éxito, arrojar un error
                  throw new Error('Error en el servidor: no se pudo eliminar la competición.');
                }

                this.hideLoading();
              } catch (error) {
                console.error('Error al eliminar el registro:', error.response ? error.response.data : error.message);
                this.hideLoading();
                // Opcional: mostrar un mensaje de error al usuario
                this.$notify({
                  type: 'error',
                  title: 'Error',
                  text: 'No se pudo eliminar la competición. Inténtalo de nuevo más tarde.',
                });
              }
            }
        },
        unpublishRound(roundId) {
            // Lógica para despublicar la ronda con el ID dado
            console.log('Despublicar ronda con ID:', roundId);
        },
        shouldDisableUnpublish(round) {
            return round.validated_at !== null || round.status_id === 6;
        },
        rule_name(rule_id) {
            let name = '';
            switch (rule_id) {
                case 1:
                    name = this.$t('configurator.title_opcion_1');
                    break;
                case 2:
                    name = this.$t('configurator.title_opcion_2');
                    break;
                case 3:
                    name = this.$t('configurator.title_opcion_3');
                    break;
                case 4:
                    name = this.$t('configurator.title_opcion_4');
                    break;
                default:
                    name = 'ERROR RULES';
                    break;
            }
            return name; // Asegúrate de devolver el valor resultante
        },
        status_name(status_id) {
            let name = '';
            switch (status_id) {
                case 1:
                    name = this.$t('configurator.status_1');
                    break;
                case 2:
                    name = this.$t('configurator.status_2');
                    break;
                case 3:
                    name = this.$t('configurator.status_3');
                    break;
                case 4:
                    name = this.$t('configurator.status_4');
                    break;
                case 5:
                    name = this.$t('configurator.status_5');
                    break;
                case 6:
                    name = this.$t('configurator.status_6');
                    break;
                case 7:
                    name = this.$t('configurator.status_7');
                    break;
                case 8:
                    name = this.$t('configurator.status_8');
                    break;
                default:
                    name = 'ERROR RULES';
                    break;
            }
            return name; // Asegúrate de devolver el valor resultante
        },
        showLoading() {
            this.$nextTick(() => {
                this.$refs.loadingModal.showLoading();
            });
        },
        hideLoading() {
            this.$nextTick(() => {
                this.$refs.loadingModal.hideLoading();
            });
        },
        toggleCollapse(index) {
            this.isExpanded = this.isExpanded.map((state, i) => (i === index ? !state : false));
        },
        toggleCollapseRounds(roundNumber) {
          this.isExpanded = { ...this.isExpanded, [roundNumber]: !this.isExpanded[roundNumber] };
        },
      toggleCollapseBestRounds() {
        this.isBestExpanded = !this.isBestExpanded;
      },
      getRoundName(roundNumber) {
        const isQualificationDual = this.competitionDetails.is_qualification_dual;
        const roundSizeId = this.competitionDetails.round_size_id;
        const skipToFinalCompetitionId = 8; // Reemplaza esto con el ID de la competición que debe omitir cuartos de final y semifinal

        // Rondas según el tamaño del torneo
        const rounds = {
          1: ['final'], // 2 competidores
          2: ['semiFinal', 'final'], // 4 competidores
          3: ['quarterFinal', 'semiFinal', 'final'], // 8 competidores
          4: ['eighthFinal', 'quarterFinal', 'semiFinal', 'final'], // 16 competidores
          5: ['sixteenthFinal', 'eighthFinal', 'quarterFinal', 'semiFinal', 'final'], // 32 competidores
        };

        // Rondas de calificación
        let qualificationRounds = [];
        if (isQualificationDual === 1) {
          qualificationRounds = ['qualification1', 'qualification2']; // Dos rondas de calificación
        } else {
          qualificationRounds = ['qualification']; // Una ronda de calificación
        }

        // Combinación de rondas de calificación y rondas del torneo
        let allRounds = [...qualificationRounds, ...(rounds[roundSizeId] || [])];

        // Comprobar si se debe omitir los cuartos de final y semifinal para una competición específica
        if (this.competitionDetails.id === skipToFinalCompetitionId) {
          allRounds = allRounds.filter(round => round !== 'semiFinal');
        }

        // Ajustar el índice de la ronda
        const roundIndex = parseInt(roundNumber, 10) - 1;

        // Verificar si el índice de la ronda es válido y retornar el nombre adecuado
        if (roundIndex >= 0 && roundIndex < allRounds.length) {
          return this.$t(`competitionDetails.rounds.${allRounds[roundIndex]}`);
        }

        // En caso de que no se cumpla ninguna condición, retornar "Round Nº: {roundNumber}"
        return this.$t('competitionDetails.rounds.round', { roundNumber });
      },
      updatePlayerCounts() {
        const rounds = {
          1: 'Final',
          2: 'Semifinal',
          3: 'Cuartos',
          4: 'Octavos',
          5: 'Dieciseisavos'
        };

        // Evaluar el valor de round_size_id y pintar un console.log según el caso
        const roundName = rounds[this.playersTest.round_size_id] || 'Valor de round_size_id no reconocido';
        console.log(roundName);

        // Inicializar las fases de la competición
        this.players.qualification1 = [];
        this.players.qualification2 = [];
        this.players.qualification = [];
        this.players.qualifiedPlayers = [];

        // Manejar la asignación a qualification
        if (this.playersTest.is_qualification_dual === 1) {
          this.players.qualification1 = this.playersTest[1];
          this.players.qualification2 = this.playersTest[2];
          console.log('Asignado a qualification1:', this.players.qualification1);
          console.log('Asignado a qualification2:', this.players.qualification2);
        } else {
          this.players.qualification = this.playersTest[1];
          console.log('Asignado a qualification:', this.players.qualification);
        }

        // Crear la siguiente fase basándose en qualification
        if (this.players.qualification.length > 0) {
          const sortedQualification = [...this.players.qualification].sort((a, b) => b.total_score - a.total_score);

          // Definir el número de jugadores que pasan a la siguiente fase
          const nextRoundSize = this.playersTest.round_size_id === 3 ? 8 :
              this.playersTest.round_size_id === 2 ? 4 :
                  this.playersTest.round_size_id === 1 ? 2 : 0;

          for (let i = 0; i < nextRoundSize; i++) {
            this.players.qualifiedPlayers.push({
              id: sortedQualification[i].id,
              name: sortedQualification[i].user.name,
              surname: sortedQualification[i].user.surname,
              total_score: null
            });
          }

          if (nextRoundSize === 8) {
            // Cuartos de final (8 jugadores)
            this.players.round8 = [
              { ...this.players.qualifiedPlayers[0] }, { ...this.players.qualifiedPlayers[7] },
              { ...this.players.qualifiedPlayers[3] }, { ...this.players.qualifiedPlayers[4] },
              { ...this.players.qualifiedPlayers[2] }, { ...this.players.qualifiedPlayers[5] },
              { ...this.players.qualifiedPlayers[1] }, { ...this.players.qualifiedPlayers[6] }
            ];
            console.log(this.players.round8);
          } else if (nextRoundSize === 4) {
            // Semifinal (4 jugadores)
            this.players.round4 = [
              { ...this.players.qualifiedPlayers[0] }, { ...this.players.qualifiedPlayers[3] },
              { ...this.players.qualifiedPlayers[1] }, { ...this.players.qualifiedPlayers[2] }
            ];
            console.log(this.players.round4);
          } else if (nextRoundSize === 2) {
            // Final (2 jugadores)
            this.players.roundFinal = [
              { ...this.players.qualifiedPlayers[0] }, { ...this.players.qualifiedPlayers[1] }
            ];
            console.log(this.players.roundFinal);
          }
        }

        // Actualizar puntajes en las fases según el id del jugador
        for (const key in this.playersTest) {
          if (Array.isArray(this.playersTest[key])) {
            this.playersTest[key].forEach(player => {
              const roundsToUpdate = ['round8', 'round4', 'roundFinal', 'thirdPlace', 'round32', 'round16'];
              roundsToUpdate.forEach(round => {
                if (this.players[round]) {
                  const playerToUpdate = this.players[round].find(p => p.id === player.id);
                  if (playerToUpdate) {
                    playerToUpdate.total_score = player.total_score;
                  }
                }
              });
            });
          }
        }

        console.log(this.players);
        console.log(this.playersTest);
      }


      ,





      beforeEnter(el) {
            el.style.opacity = 0;
        },
        enter(el, done) {
            el.offsetHeight; // Activa el reflujo
            el.style.transition = "opacity 0.5s";
            el.style.opacity = 1;
            done();
        },
        leave(el, done) {
            el.style.transition = "opacity 0.2s";
            el.style.opacity = 0;
            done();
        },
        cancel(){
            this.isExpanded[6] = false;
            this.isExpanded[7] = true;
            this.formData = {
                name: '',
                round_size_id: '',
                rule_id: '',
                type_id: '',
            };
        },
        async createForm(){
            this.toggleCollapse(6);
            try {
                this.showLoading();
                const response = await this.$axios.get(`/competitions`,{
                    headers: {
                        Authorization: `Bearer ${this.$store.getters.getToken}`,
                    },
                })
                    .catch(error => {
                        console.error('Error al obtener la lista de países:', error);
                    });
               /* const countriesData = response.data.countries.map(country => {
                    let translatedName = country.name;
                    let langCode = this.$i18n.locale;
                    if (langCode !== 'en' && country.translations) {
                        try {
                            const translationsObject = JSON.parse(country.translations);
                            if (langCode === 'jp'){langCode = 'ja'}
                            translatedName = translationsObject[langCode] || country.name;
                        } catch (error) {
                            console.error('Error al parsear las traducciones:', error);
                        }
                    }

                    return {
                        id: country.id,
                        name: translatedName,
                    };
                });
                this.countries = countriesData.sort((a, b) => a.name.localeCompare(b.name));*/

                const mapObjetsCompetition = Objets => {
                    return Objets.map(objet => ({
                        value: objet.id,
                        name: objet.name,
                    }));
                };
                this.round_sizes = mapObjetsCompetition(response.data.round_sizes);
                this.rules = mapObjetsCompetition(response.data.rules);
                this.types = mapObjetsCompetition(response.data.types);

                this.hideLoading();
            } catch (error) {
                console.error('Error loading cities:', error);
            }
        },
        async submitFormCreate() {
            try {
                this.showLoading();
                const response = await this.$axios.post(`/competitions/store`,{
                    formCreate : this.formData
                },{
                    headers: {
                        Authorization: `Bearer ${this.$store.getters.getToken}`,
                    },
                })
                .catch(error => {
                        console.error('Error al almacenar la competicion:', error);
                });
                this.userCompetitions = response.data.competitions;
                this.isExpanded[6] = false;
                this.isExpanded[7] = true;
                this.formData = {
                    name: '',
                        round_size_id: '',
                        rule_id: '',
                        type_id: '',
                };
                this.hideLoading();
            } catch (error) {
                console.error('Error saving competition:', error);
            }
        },
        handleConfirmed() {
          if (!this.pendingConfirmResolver) {
            return;
          }

          const resolve = this.pendingConfirmResolver;
          this.resetConfirmationModalState();
          resolve(true);
        },
        cancelModal() {
          if (!this.pendingConfirmResolver) {
            this.resetConfirmationModalState();
            return;
          }

          const resolve = this.pendingConfirmResolver;
          this.resetConfirmationModalState();
          resolve(false);
        },
        resetConfirmationModalState() {
          this.pendingConfirmResolver = null;
          this.showCancel = false;
          this.modalMessage = '';
        },
        confirmWithModal(message) {
          return new Promise((resolve) => {
            this.pendingConfirmResolver = resolve;
            this.showCancel = true;
            this.modalMessage = message;
            this.$refs.confirmationModal.openModal();
          });
        }
    },
    components: {
      ConfirmationModal,
      LoadingModal,
      BracketGrid
    },
};
</script>

<style scoped>
.box_component {
  width: 100%;
  max-width: 100%;
    margin: 15px auto;
}
.height_box{
    max-height: 400px !important;
    overflow-y: auto !important;
}
.table {
    font-size: 1rem;
}
ul.list-btn{
    width: 170px;
    list-style: none;
    padding: 0;
    margin: 0 auto;
}
ul.list-btn li{
    display: inline-block;
    margin-right: 8px;
}
.best-result {
  background-color: rgba(14, 183, 54, 0.25) !important; /* Verde claro */
}
.rounded-circle {
  border-radius: 50%;
  width: 50px; /* Ajusta este valor según el tamaño deseado */
  height: 50px; /* Ajusta este valor según el tamaño deseado */
  object-fit: cover; /* Asegura que la imagen se recorte correctamente dentro del círculo */
}

@media (max-width: 768px) {
  .table {
    font-size: 0.6rem;
  }
  .table td {
    padding: 0.20rem;
  }
}
</style>
